import { fieldTypes } from '../common/form/fieldTypes';
import { isEditableField, isContainer, isWidget } from "../../MPP-Common-SPA/common/form/fieldTypes";
import { WIDGET_SCHEMAS } from '../common/constants/schemas';
import { evaluate } from "../../MPP-Common-SPA/utils/globalUtility";

export const isHTML = (content) => {
  var doc = new DOMParser().parseFromString(content, "text/html");
  return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
};

export const isEmptyObject = (obj) => {
  if (!obj || obj === null || obj === undefined) {
      return true
  }
  
  return Object.keys(obj)?.length === 0 && obj.constructor === Object;
}

// Gets the fields visible on the page in the order they are rendered
export const getVisibleFields = (data, fields, context, getRefData) => {
  const visibleFields = [];
  
  // Use for...of to maintain order and handle async properly
  for (const field of (fields ?? [])) {
    if (!!field.condition?.stepName && context.getStepData) {
      const stepData = context.getStepData(field.condition.stepName);
      context[field.condition.stepName] = stepData;
    }
    if (!!field.condition?.category) {
      context[field.condition?.category] = getRefData({category: field.condition?.category});
    }
  
    const expressionValue = evaluate(field.condition, context, data || {});

    if (expressionValue === true) {
      if (field.condition?.action === 'hidden') {
        // Field is hidden, so continue to next iteration
        continue; 
      }
    }
    
    // Enumerate values for field.
    if (isContainer(field.type)) {
      const childFields = getVisibleFields(data, field.fields, context, getRefData);
      visibleFields.push(...childFields); // Merge child results
    }
    if (!isWidget(field.type) && isEditableField(field.type)) {
      const { name, extraName } = field.properties;
      visibleFields.push(name);
      extraName && visibleFields.push(extraName);
    }
    if (field.type === fieldTypes.value) {
      if (field.properties.method === 'getRefValue') {
        const { name, extraName } = field.properties;
        visibleFields.push(name);
        extraName && visibleFields.push(extraName);
      } else {
        Object.keys(field.properties.params ?? []).forEach(name => {
          visibleFields.push(name);    
        });
      }
    }

    const widgetSchema = WIDGET_SCHEMAS[field.type];
    if(widgetSchema?.fields){
      visibleFields.push(...(Object.keys(widgetSchema.fields)));
    }
  }
  
  return visibleFields;
}